var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-form-second-step"},[_c('div',{staticClass:"d-flex flex-row bd-highlight mb-3"},[_c('div',[_c('DynamicIcon',{attrs:{"icon":"padlock","classString":'container-modal-title-icon mr-2'}})],1),_vm._m(0)]),_c('div',{staticClass:"d-flex"},[_c('h6',[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color"},[_c('h5',[_vm._v("Token de Acesso")])])
}]

export { render, staticRenderFns }